import { InputAdornment as MuiInputAdornment } from '@mui/material';

export default MuiInputAdornment;
